<template>
  <section>
    <transition name="fade">
      <section style="position: absolute; width: 100%;">
        <v-container v-if="preloader">
          <div class="text-center">
            <v-progress-circular indeterminate></v-progress-circular>
          </div>
        </v-container>
      </section>
    </transition>

    <div :class="showContent" class="row custom-appointments">
      <div class="col-12 mt-0 pt-0">
        <EditedUser
          :userID="userID"
          :typeSkill="typeSkill"
          secondBtn="true"
          :emptyUser="getEmpty()"
          :users="users"
          @getSkillType="getSkillTypeCurrent"
          @getCurrentUser="getCurrentUserData"
          @addInterview="addInterview"
        />

        <transition name="fade">
          <section style="position: absolute; width: 100%;">
            <v-container v-if="updateLoad">
              <div class="text-center">
                <v-progress-circular indeterminate></v-progress-circular>
              </div>
            </v-container>
          </section>
        </transition>

        <div v-if="!updateLoad" style="margin-top: 20px;" class="custom-accordion">
          <div class="container-color" style="position:relative; padding: 16px 30px 30px;">
            
            <div class="rights-table__head">
              <div
                v-for="btn in rightsButtons"
                :key="'head_' + btn.id"
                class="rights-table__col rights-table__col--right"
                :title="btn.description"
              >
                {{ btn.description }}
              </div>

              <div class="rights-table__col rights-table__col--title">{{ titleSkill }}</div>
            </div>

            <div v-for="itemArea in (data && data.areas ? data.areas : [])" :key="itemArea.id">
              <div v-if="itemArea.type !== 'task' && itemArea.type !== 'question'">

                <!-- ROW: AREA -->
                <div class="rights-table__row rights-table__row--lvl1">

                  <!-- права -->
                  <div
                    v-for="btn in rightsButtons"
                    :key="'area_' + itemArea.id + '_' + btn.id"
                    class="rights-table__col rights-table__col--right"
                  >
                    <v-checkbox
                      class="rights-table__vcb"
                      :color="btn.color"
                      hide-details
                      :ripple="false"
                      :input-value="getRight(itemArea, btn.title)"
                      @click.native.stop.prevent="toggleRight(itemArea, btn)"
                    />
                  </div>

                  <div class="rights-table__col rights-table__col--title">
                    <div class="custom-accordion_list flex">

                      <div class="custom-accordion_left-action">
                        <div v-if="hasVisibleChildren(itemArea)">
                          <v-btn
                            v-if="!arrayOpen.includes(itemArea.id)"
                            class="btn-open-block custom-check"
                            variant="text"
                            text
                            @click="openBlock(itemArea.id)"
                          >
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                          <v-btn
                            v-else
                            class="btn-open-block custom-check"
                            variant="text"
                            text
                            @click="openBlock(itemArea.id)"
                          >
                            <v-icon>mdi-minus</v-icon>
                          </v-btn>
                        </div>
                      </div>

                      <div class="container-title">
                        <h5>
                          <b @click="goTo(itemArea)">{{ itemArea.title }}</b>
                          <span v-if="itemArea.description"> - {{ itemArea.description }}</span>
                        </h5>
                      </div>

                    </div>
                  </div>

                </div>

                <div v-show="arrayOpen.includes(itemArea.id)">
                  <div v-for="itemCompetency in (itemArea.children || [])" :key="itemCompetency.id">
                    <div v-if="itemCompetency.type !== 'task' && itemCompetency.type !== 'question'">

                      <!-- ROW: COMPETENCY -->
                      <div class="rights-table__row rights-table__row--lvl2">

                        <!-- права -->
                        <div
                          v-for="btn in rightsButtons"
                          :key="'comp_' + itemCompetency.id + '_' + btn.id"
                          class="rights-table__col rights-table__col--right"
                        >
                          <v-checkbox
                            class="rights-table__vcb"
                            :color="btn.color"
                            hide-details
                            :ripple="false"
                            :input-value="getRight(itemCompetency, btn.title)"
                            @click.native.stop.prevent="toggleRight(itemCompetency, btn)"
                          />
                        </div>

                        <div class="rights-table__col rights-table__col--title">
                          <div class="custom-accordion_list flex">

                            <div class="custom-accordion_left-action">
                              <div v-if="hasVisibleChildren(itemCompetency)">
                                <v-btn
                                  v-if="!arrayOpen.includes(itemCompetency.id)"
                                  class="btn-open-block custom-check"
                                  variant="text"
                                  text
                                  @click="openBlock(itemCompetency.id)"
                                >
                                  <v-icon>mdi-plus</v-icon>
                                </v-btn>
                                <v-btn
                                  v-else
                                  class="btn-open-block custom-check"
                                  variant="text"
                                  text
                                  @click="openBlock(itemCompetency.id)"
                                >
                                  <v-icon>mdi-minus</v-icon>
                                </v-btn>
                              </div>
                            </div>

                            <div class="container-title">
                              <h5>
                                <b @click="goTo(itemCompetency, [itemArea])">{{ itemCompetency.title }}</b>
                                <span v-if="itemCompetency.description"> - {{ itemCompetency.description }}</span>
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-show="arrayOpen.includes(itemCompetency.id)">
                        <div v-for="itemTheme in (itemCompetency.children || [])" :key="itemTheme.id">
                          <div v-if="itemTheme.type !== 'task' && itemTheme.type !== 'question'">

                            <!-- ROW: THEME -->
                            <div class="rights-table__row rights-table__row--lvl3">

                              <!-- права -->
                              <div
                                v-for="btn in rightsButtons"
                                :key="'theme_' + itemTheme.id + '_' + btn.id"
                                class="rights-table__col rights-table__col--right"
                              >
                                <v-checkbox
                                  class="rights-table__vcb"
                                  :color="btn.color"
                                  hide-details
                                  :ripple="false"
                                  :input-value="getRight(itemTheme, btn.title)"
                                  @click.native.stop.prevent="toggleRight(itemTheme, btn)"
                                />
                              </div>

                              <div class="rights-table__col rights-table__col--title">
                                <div class="custom-accordion_list flex">

                                  <div class="custom-accordion_left-action">
                                    <div v-if="hasVisibleChildren(itemTheme)">
                                      <v-btn
                                        v-if="!arrayOpen.includes(itemTheme.id)"
                                        class="btn-open-block custom-check"
                                        variant="text"
                                        text
                                        @click="openBlock(itemTheme.id)"
                                      >
                                        <v-icon>mdi-plus</v-icon>
                                      </v-btn>
                                      <v-btn
                                        v-else
                                        class="btn-open-block custom-check"
                                        variant="text"
                                        text
                                        @click="openBlock(itemTheme.id)"
                                      >
                                        <v-icon>mdi-minus</v-icon>
                                      </v-btn>
                                    </div>
                                  </div>

                                  <div class="container-title">
                                    <h5>
                                      <b @click="goTo(itemTheme, [itemArea, itemCompetency])">{{ itemTheme.title }}</b>
                                      <span v-if="itemTheme.description"> - {{ itemTheme.description }}</span>
                                    </h5>
                                  </div>
                                </div>
                              </div>

                            </div>

                            <div v-show="arrayOpen.includes(itemTheme.id)">
                              <div v-for="itemSubtopic in (itemTheme.children || [])" :key="itemSubtopic.id">
                                <div v-if="itemSubtopic.type !== 'task' && itemSubtopic.type !== 'question'">

                                  <!-- ROW: SUBTOPIC -->
                                  <div class="rights-table__row rights-table__row--lvl4">

                                    <!-- права -->
                                    <div
                                      v-for="btn in rightsButtons"
                                      :key="'sub_' + itemSubtopic.id + '_' + btn.id"
                                      class="rights-table__col rights-table__col--right"
                                    >
                                      <v-checkbox
                                        class="rights-table__vcb"
                                        :color="btn.color"
                                        hide-details
                                        :ripple="false"
                                        :input-value="getRight(itemSubtopic, btn.title)"
                                        @click.native.stop.prevent="toggleRight(itemSubtopic, btn)"
                                      />
                                    </div>

                                    <div class="rights-table__col rights-table__col--title">
                                      <div class="custom-accordion_list flex">

                                        <div class="custom-accordion_left-action"></div>
                                        
                                        <div class="container-title">
                                          <h5>
                                            <b @click="goTo(itemSubtopic, [itemArea, itemCompetency, itemTheme])">{{ itemSubtopic.title }}</b>
                                            <span v-if="itemSubtopic.description"> - {{ itemSubtopic.description }}</span>
                                          </h5>
                                        </div>
                                      </div>
                                    </div>
                                    
                                  </div>

                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

              </div>
            </div>


          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import GlobalRequest from "@/plugins/globalRequest"
import EditedUser from "@/components/Cards/EditedUser.vue";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";

export default {
  name: "AppointmentCompetention",
  components: {
    EditedUser,
  },

  inject: ["usersStore", "openInterview"],

  data() {
    return {
      data: null, // hardSkills/softSkills объект
      titleSkill: "",
      userData: {},

      preloader: true,
      updateLoad: false,
      preloaderBtn: false,

      userID: 0,
      typeSkill: "", // hs / ss

      errorText: "",
      infoText: "",
      arrayOpen: [],

      rightsButtons: [
        { id: 1, title: "canView",       right: 'VIEW',           color: "#5d30b2", description: "просмотр компетенции", },
        { id: 2, title: "canViewScore",  right: 'VIEW_SCORE',     color: "#3091B2",   description: "просмотр оценки", },
        { id: 3, title: "canPostScore",  right: 'POST_SCORE',     color: "#229863",  description: "оценка компетенции", },
        { id: 4, title: "canPostAnswer", right: 'POST_ANSWER',    color: "#BB992F", description: "ответ на задание", },
        { id: 5, title: "assigned",      right: 'ASSIGN_ELEMENT', color: "#B33C12",    description: "назначить компетенцию" },
      ],

      ignoreInitialSkillEmit: true,
    };
  },

  computed: {
    users() {
      return this.usersStore.users;
    },
    showContent() {
      return this.preloader ? "hidden-block" : "show-block";
    }
  },

  watch: {
    users: {
      immediate: true,
      handler: function (val) {
        if (!val || !val.length) return;

        if (!this.userID || this.userID === 0) {
          const persisted = this.readPersistedSelection();
          if (persisted && persisted.userID) {
            this.userID = persisted.userID;
          }
        }

        if (!this.userID || this.userID === 0) {
          this.trySetFirstUserFromList();
        }

        if (!this.typeSkill) {
          const persisted = this.readPersistedSelection();
          if (persisted && persisted.typeSkill) this.typeSkill = persisted.typeSkill;
        }
        if (!this.typeSkill) this.typeSkill = "hs";

        this.persistSelection();
        this.getCompetentions(this.userID, this.typeSkill);
      }
    }
  },

  mounted() {

    if (this.$route.query.userID) this.userID = Number(this.$route.query.userID);
    if (this.$route.query.typeSkill) this.typeSkill = String(this.$route.query.typeSkill);

    if (!this.userID || this.userID === 0 || !this.typeSkill) {
      var persisted = this.readPersistedSelection();

      if ((!this.userID || this.userID === 0) && persisted.userID) {
        this.userID = persisted.userID;
      }

      if (!this.typeSkill && persisted.typeSkill) {
        this.typeSkill = persisted.typeSkill;
      }
    }

    if (!this.typeSkill) this.typeSkill = "hs";

    this.ignoreInitialSkillEmit = true;
    this.$nextTick(() => {
      this.ignoreInitialSkillEmit = false;
    });

    if (!this.userID || this.userID === 0) {
      this.trySetFirstUserFromList();
    }

    this.persistSelection();

    

    // await this.getCompetentions(this.userID, this.typeSkill);
  },

  methods: {

    // не раскрывать, если внутри только task/question
    hasVisibleChildren(node) {
      if (!node || !node.children) return false;
      return node.children.filter(function (c) {
        return c.type !== "task" && c.type !== "question";
      }).length > 0;
    },

    openBlock(id) {
      var idx = this.arrayOpen.indexOf(id);
      if (idx !== -1) this.arrayOpen.splice(idx, 1);
      else this.arrayOpen.push(id);
    },

    getVisible(id) {
      return this.arrayOpen.indexOf(id) !== -1 ? "display: block" : "display: none";
    },

    getEmpty() {
      return !(this.userID && this.userID !== 0);
    },

    // targetRights
    getRight(node, key) {
      if (!node || !node.targetRights) return false;
      return !!node.targetRights[key];
    },

    // targetRights есть у всех элементов
    normalizeRightsTree(node) {
      if (!node) return;

      if (!node.targetRights) {
        this.$set(node, "targetRights", {
          canView: false,
          canViewScore: false,
          canPostAnswer: false,
          canPostScore: false,
          assigned: false,
        });
      }

      if (node.children && node.children.length) {
        for (var i = 0; i < node.children.length; i++) {
          this.normalizeRightsTree(node.children[i]);
        }
      }
    },

    // применить право рекурсивно вниз
    // applyRightDown(children, key, value) {
    //   if (!children || !children.length) return;

    //   for (var i = 0; i < children.length; i++) {
    //     var child = children[i];

    //     if (!child.targetRights) {
    //       this.$set(child, "targetRights", {
    //         canView: false,
    //         canViewScore: false,
    //         canPostAnswer: false,
    //         canPostScore: false,
    //         assigned: false,
    //       });
    //     }

    //     // ключ
    //     this.$set(child.targetRights, key, value);

    //     // рекурсия
    //     if (child.children && child.children.length) {
    //       this.applyRightDown(child.children, key, value);
    //     }
    //   }
    // },

    // клик по чекбоксу права
    async toggleRight(node, btn) {
      if (!node || !btn) return;

      // console.log(node)

      const hasRight = node.targetRights && node.targetRights[btn.title] === true;
      const action = hasRight ? "revoke" : "assign";

      const body = {
        elementId: node.id,
        subordinateId: this.userID,
        right: btn.right,
        action: action,
        returnType: "branch"
      };

      const res = await GlobalRequest.request(`/assigment/manage-right`, "POST", body);
      if (!res || res && res.error) {
        await this.notifyVue("bottom", "right", "Не удалось изменить назначение права");
        return;
      }

      const skillKey = this.typeSkill === "hs" ? "hardSkills" : "softSkills";
      const branch = res && res[skillKey] && res[skillKey].areas ? res[skillKey].areas[0] : null;

      if (branch) this.applyBranchRights(branch);
    },

    async notifyVue(verticalAlign, horizontalAlign, text) {
      this.$notify({
        component: NotificationTemplate,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: "danger",
        message: text,
      });
    },

    getSkillTypeCurrent(type) {
      if (this.ignoreInitialSkillEmit && this.typeSkill) return;
      
      if (String(type) === String(this.typeSkill)) return;

      this.updateLoad = true;
      this.typeSkill = type;
      this.persistSelection();
      this.getCompetentions(this.userID, type);
    },

    getCurrentUserData(id) {
      var nextId = Number(id || 0);
      if (!nextId || nextId === Number(this.userID)) return;

      this.updateLoad = true;
      this.userID = id; 
      this.persistSelection();
      this.getCompetentions(id, this.typeSkill);
    },

    async getCompetentions(idCurrentUser, currentTypeSkill) {
      if (idCurrentUser) this.userID = idCurrentUser;
      if (currentTypeSkill) this.typeSkill = currentTypeSkill;
      if (!this.typeSkill) this.typeSkill = "hs";

      if (!this.userID) {
        this.preloader = false;
        this.updateLoad = false;
        return;
      }

      var resp = await GlobalRequest.request("/competencies/" + this.userID, "GET");

      var hs = resp  ? resp.hardSkills : null;
      var ss = resp  ? resp.softSkills : null;

      if (this.typeSkill === "hs") {
        this.data = hs;
        this.titleSkill = hs && hs.title ? hs.title : "Hard Skills";
      } else {
        this.data = ss;
        this.titleSkill = ss && ss.title ? ss.title : "Soft Skills";
      }

      if (this.data && this.data.areas && this.data.areas.length) {
        for (var i = 0; i < this.data.areas.length; i++) {
          this.normalizeRightsTree(this.data.areas[i]);
        }
      }

      this.persistSelection();

      this.preloader = false;
      this.updateLoad = false;
    },

    buildPayloadNode(node) {
      if (!node) return null;

      var out = {
        elementId: node.id,
        type: node.type,
        targetRights: node.targetRights ? {
          canView: !!node.targetRights.canView,
          canViewScore: !!node.targetRights.canViewScore,
          canPostAnswer: !!node.targetRights.canPostAnswer,
          canPostScore: !!node.targetRights.canPostScore,
          assigned: !!node.targetRights.assigned,
        } : {
          canView: false, canViewScore: false, canPostAnswer: false, canPostScore: false, assigned: false,
        },
        children: [],
      };

      if (node.children && node.children.length) {
        for (var i = 0; i < node.children.length; i++) {
          var child = this.buildPayloadNode(node.children[i]);
          if (child) out.children.push(child);
        }
      }

      return out;
    },

    async saveApplication() {
      this.errorText = "";
      this.infoText = "";
      this.preloaderBtn = true;

      try {
        var areas = [];
        var list = this.data && this.data.areas ? this.data.areas : [];

        for (var i = 0; i < list.length; i++) {
          areas.push(this.buildPayloadNode(list[i]));
        }

        var body = {
          tag: this.typeSkill,  // hs/ss
          areas: areas,
        };

        var res = await GlobalRequest.request("/user/" + this.userID + "/competencies/manage", "POST", body);

        if (res && res.success) this.infoText = "Компетенции успешно назначены";
        else {
          this.errorText = "При назначении произошла ошибка";
          alert(this.errorText);
        }
      } catch (e) {
        this.errorText = "Ошибка запроса";
        alert(this.errorText);
      } finally {
        this.preloaderBtn = false;
      }
    },

    persistSelection() {
      if (this.userID) localStorage.setItem("appointment_user", String(this.userID));
      if (this.typeSkill) localStorage.setItem("appointment_skill", String(this.typeSkill));
    },

    readPersistedSelection() {
      var storedUser = localStorage.getItem("appointment_user");
      var storedSkill = localStorage.getItem("appointment_skill");

      return {
        userID: storedUser ? Number(storedUser) : 0,
        typeSkill: storedSkill ? storedSkill : "",
      };
    },

    trySetFirstUserFromList() {
      var list = this.users || [];
      if (!list.length) return;

      var first = list[0];

      var firstId = 0;
      if (first && typeof first.id !== "undefined") firstId = Number(first.id);
      else if (first && typeof first.value !== "undefined") firstId = Number(first.value);

      if (firstId) this.userID = firstId;
    },
    
    rightsToTarget(sub) {
      sub = sub || {};
      return {
        canView: !!sub.canView,
        canViewScore: !!sub.canViewScore,
        canPostAnswer: !!sub.canPostAnswer,
        canPostScore: !!sub.canPostScore,
        assigned: !!sub.assigned,
      };
    },

    applyBranchRights(branchNode) {
      const rootList = (this.data && this.data.areas) ? this.data.areas : [];
      if (!branchNode || !rootList.length) return;

      const updateLocalById = (localNode, incoming) => {
        if (!localNode.targetRights) {
          this.$set(localNode, "targetRights", {
            canView: false,
            canViewScore: false,
            canPostAnswer: false,
            canPostScore: false,
            assigned: false,
          });
        }

        const next = this.rightsToTarget(incoming.subordinateRights);

        this.$set(localNode.targetRights, "canView", next.canView);
        this.$set(localNode.targetRights, "canViewScore", next.canViewScore);
        this.$set(localNode.targetRights, "canPostAnswer", next.canPostAnswer);
        this.$set(localNode.targetRights, "canPostScore", next.canPostScore);
        this.$set(localNode.targetRights, "assigned", next.assigned);
      };

      const findLocal = (list, id) => {
        for (let i = 0; i < list.length; i++) {
          const n = list[i];
          if (String(n.id) === String(id)) return n;
          if (n.children && n.children.length) {
            const f = findLocal(n.children, id);
            if (f) return f;
          }
        }
        return null;
      };

      const walkIncoming = (incoming) => {
        if (!incoming || !incoming.id) return;

        const local = findLocal(rootList, incoming.id);
        if (local) updateLocalById(local, incoming);

        if (incoming.children && incoming.children.length) {
          for (let i = 0; i < incoming.children.length; i++) {
            walkIncoming(incoming.children[i]);
          }
        }
      };

      walkIncoming(branchNode);
    },

    goTo(item, chain) {
      if (!item || !item.id || !item.type) return;

      // массив родителей
      var parentsChain = Array.isArray(chain) ? chain : [];

      var newParents = parentsChain.map(function(n) {
        return { id: n.id, type: n.type };
      });

      // breadcrumbs в localStorage
      var crumbs = [
        { text: "Области знаний", type: "areasLayout", id: null }
      ];

      for (var i = 0; i < parentsChain.length; i++) {
        var p = parentsChain[i];
        crumbs.push({
          text: p.title || this.getTitleByType(p.type) || p.type,
          type: p.type,
          id: p.id
        });
      }

      // текущий элемент
      crumbs.push({
        text: item.title || this.getTitleByType(item.type) || item.type,
        type: item.type,
        id: item.id
      });

      localStorage.setItem("category_breadcrumbs", JSON.stringify(crumbs));

      const query = {
        ...this.$route.query,
        userID: this.userID
      };

      this.$router.push({
        name: item.type, // area/competency/theme/subtopic
        params: {
          id: item.id,
          parents: newParents
        },
        query
      });
    },

    getTitleByType(type) {
      const map = {
        area: "Компетенции",
        competency: "Темы",
        theme: "Подтемы",
        subtopic: "Вопросы и задания"
      };
      return map[type] || "";
    },

    // Назначение интервью
    addInterview(id) {
      this.openInterview(id);
    },

  },
};
</script>

<style scoped>

.rights {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.rights--indent { margin-left: 20px; }

.rights__cb {
  margin: 0 4px 0 0 !important;
  padding: 0 !important;
  max-width: 56px;
}

.custom-check { 
  height: 35px; 
}
.container-title { 
  padding: 0; 
}
.container-content { 
  padding: 0 0 0 26px; 
}
.container-title input { 
  cursor: pointer; 
}
.container-title h5 { 
  margin: 0; 
}
.container-title h5 b { 
  transition: 0.3s;
  cursor: pointer;
}
.container-title h5 b:hover { 
  text-decoration: underline;
}
.flex { 
  display: flex; 
  align-items: center; 
  padding-bottom: 5px;
}
.pd-flex { 
  padding: 5px 31px; 
}
.custom-accordion .v-expansion-panel-header { 
  min-height: 0 !important; 
  height: 50px !important; 
}
.res-text { 
  text-align: center; 
  max-width: 300px; 
  margin: 0 auto; 
}
.res-text p { 
  font-size: 14px !important; 
}

.btn-open-block{
  padding: 0 !important;
  width: 16px;
  height: 16px !important;
  min-width: 10px !important;
  font-size: 10px;
  border: 1px solid #737373;
  top: -1px;
  border-radius: 3px;
}
.horizontal-line {
/* .btn-open-block::after{ */
  content: " ";
  position: absolute;
  width: 20px;
  height: 1px;
  border-top: 1px dashed #888888;
  left: -20px;
  top: 11px;
}
.btn-open-block1::after{
  content: " ";
  position: absolute;
  width: 40px;
  height: 1px;
  border-top: 1px dashed #888888;
  left: -20px;
  top: 16px;
}
.container-area { 
  /* position: relative; */
  /* padding: 10px 0;  */
}
/* .container-area::after{ */
.vertical-line {
  content: " ";
  position: absolute;
  width: 10px;
  height: 100%;
  border-left: 1px dashed #888888;
  left: -20px;
  top: 0;
}
.btn-open-block span{
  padding: 0;
  width: 20px;
  height: 20px;
  min-width: 10px;
  font-size: 10px;
  border: 1px solid #c3c3c3;
}
.btn-open-block i { 
  font-size: 14px; 
  color: #c3c3c3; 
}

.marl-20 { margin-left: 29px; }
.marl-20::after{
  content: " ";
  position: absolute;
  width: 50px;
  height: 1px;
  border-top: 1px dashed #888888;
  left: -20px;
  top: 16px;
}

.rights {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-right: 10px;
}

.rights-btn {
  height: 20px;
  width: 20px;
  outline: 0;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  transition: 0.3s ease;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0;
  position: relative;
}

.rights-btn.gray {
  filter: grayscale(1);
  opacity: 0.6;
}

.rights-btn i.v-icon {
  position: absolute;
  font-size: 18px;
  line-height: 1;
  left: 1px;
  top: 0;
}

button.blueBtn, button.blueBtn i.v-icon { background-color: #7CE4FE; color: #3091B2; }
button.greenBtn, button.greenBtn i.v-icon { background-color: #8EF3C5; color: #229863; }
button.yellowBtn, button.yellowBtn i.v-icon { background-color: #FFE28C; color: #BB992F; }
button.redBtn, button.redBtn i.v-icon { background-color: #FF8F5E; color: #B33C12; }
button.violetBtn, button.violetBtn i.v-icon { background-color: #be7cfe; color: #5d30b2; }

.uppercase {
  text-transform: uppercase;
}
.flex-block {
  display: flex;
  gap: 40px;
  align-items: flex-start;
}
.rights-absolute {
  position: absolute;
  left: 40px;
}
.custom-accordion_list {
  position: relative;
}
.hidden-block {
  opacity: 0;
}
.show-block {
  opacity: 1;
}
.mb-25 {
  margin-bottom: 25px !important;
}

/* Таблица прав */
.rights-table__head,
.rights-table__row {
  display: grid;
  grid-template-columns: repeat(5, 100px) 1fr; 
  align-items: center;
  gap: 10px;
}

.rights-table__head {
  padding: 8px 0 12px;
  border-bottom: 1px solid #e6e6e6;
  margin-bottom: 10px;
  position: sticky;
  top: 0;
  z-index: 2;
}

.rights-table__row {
  padding: 2px 0;
  border-bottom: 1px dashed #eee;
}

.rights-table__col--title {
  min-width: 0;
}

.rights-table__col--right {
  display: flex;
  justify-content: center;
}

.rights-table__checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

/* уровни (визуальная вложенность) */
.rights-table__row--lvl1 .rights-table__col--title { padding-left: 0; }
.rights-table__row--lvl2 .rights-table__col--title { padding-left: 18px; }
.rights-table__row--lvl3 .rights-table__col--title { padding-left: 36px; }
.rights-table__row--lvl4 .rights-table__col--title { padding-left: 54px; }

.rights-table__head .rights-table__col--right,
.rights-table__head .rights-table__col--title {
  font-size: 13px;
  line-height: 1.2;
  font-family: "Montserrat", sans-serif;
}
.rights-table__head .rights-table__col--right {
  text-align: center;
}
.rights-table__head .rights-table__col--title {
  font-weight: 600;
  font-size: 16px;
}
.custom-accordion_left-action {
  min-width: 22px;
}
.container-title h5 {
  font-size: 14px;
  line-height: 1.2;
}
.v-input--selection-controls {
  padding-top: 0;
}
.rights-table__head > :last-child,
.rights-table__col:last-child {
  margin-left: 25px;
}
.rights-table__row .rights-table__vcb .v-icon {
  font-size: 20px !important;
}
.custom-accordion_list.flex {
  gap: 5px;
}
</style>
